import React from 'react';

import { compose } from 'redux';

import withAccessControl from 'common/routing/withAccessControl';
import AdminIntegrationSettings from 'common/subdomain/admin/AdminIntegrationSettings/AdminIntegrationSettings';
import { MCPClientIntegrations } from 'common/subdomain/admin/AdminIntegrationSettings/constants';
import { RoutePermissions, testEveryPermission } from 'common/util/permissions';

export const sections = [
  {
    integrations: MCPClientIntegrations,
  },
];

const AdminIntegrationSettingsAI = () => {
  return (
    <AdminIntegrationSettings
      settingsTitle="AI"
      settingsDescription="Integrate Canny with LLMs and AI chats to help you analyze your feedback, streamline workflows, and unlock smarter insights across your product."
      sections={sections}
    />
  );
};

export default compose(
  withAccessControl(
    testEveryPermission(RoutePermissions.adminSettings.integrations.ai),
    '/admin/settings',
  ),
)(AdminIntegrationSettingsAI) as unknown as React.FC;
